export const seeds = "Seeds"
export const ferts = "Fertilisers"
export const manure = "Manure"
